import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/sx/logo-black.svg")